import { Type } from '@angular/core';

export class LegendItem {
  constructor(
    public componentClass: Type<any>,
    public name?: Type<any>,
    public path?: string,
    public active?: boolean,
    public data?: any
        
    ) {}
}
